import { useState, useEffect, useRef } from 'react'
import eventdata from "../data/events.json";
import Papa from 'papaparse'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResultEntry = () => {
	const formRef = useRef(null)
	const scriptUrl = "https://script.google.com/macros/s/AKfycbyMsmsaw2_0KbKVbLMW9E-QgTVT9fSRFJZ1KV8SCpsNCMMbLi1D0zM-aqboLAb96Ui5/exec"
	const [loading, setLoading] = useState(false)
	const [event, setEvent] = useState(Object.keys(eventdata)[0])
	const [first, setFirst] = useState()
	const [second, setSecond] = useState()
	const [third, setThird] = useState()
	const [data, setData] = useState([]);

	useEffect(() => {
		Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vRPP1t7aXtfyB4ipXGiR0c0u077PlCgepfXodO5Wj7Tb4UZ95q5wjyF8VwKnGn-2V6iY16ssHBugm20/pub?gid=0&single=true&output=csv", {
			download: true,
			header: true,
			skipEmptyLines: true,
			complete: function (results) {
				setData(results.data);
			},
		})
	}, [event]);

	const handleSubmit = (e) => {
		e.preventDefault()
		setLoading(true)

		fetch(scriptUrl, {
			method: 'POST',
			body: new FormData(formRef.current),

		}).then(res => {
			console.log("SUCCESSFULLY SUBMITTED")
			setLoading(false)
			formRef.current.reset();
			toast.success('Successfully Submitted', {
				position: "top-right",
				autoClose: 3000,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "dark",
			});
		})
		.catch((err) => {
			console.log(err);
			toast.error('Not Submitted', {
				position: "top-right",
				autoClose: 3000,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "dark",
			});
		})
	}

	return (
		<form ref={formRef} onSubmit={handleSubmit} name="google-sheet" className="my-8">

			<ToastContainer />

			<div className="mb-4">
				<label htmlFor='Event' className="block font-medium mb-2">
					Event
				</label>
				<select name="Event" value={event} onChange={(e) => setEvent(e.target.value)} className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight" required>
					{Object.keys(eventdata).map((event) => {
						return <option value={event} id={event}>{eventdata[event].title}</option>
					})}
				</select>
			</div>

			<h3 className="text-2xl text-center font-bold border-t pt-8 mt-8 mb-3">First</h3>

			<div className="mb-4">
				<label htmlFor='First House' className="block font-medium mb-2">
					First House
				</label>
				<select name="FirstHouse" value={first} onChange={(e) => setFirst(e.target.value)} className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight" required>
					<option value="" id="" selected>--select--</option>
					<option value="Aryans" id="Aryans">Aryans</option>
					<option value="Mughals" id="Mughals">Mughals</option>
					<option value="Rajputs" id="Rajputs">Rajputs</option>
					<option value="Spartans" id="Spartans">Spartans</option>
					<option value="Vikings" id="Vikings">Vikings</option>
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='First Name' className="block font-medium mb-2">
					First Name
				</label>
				{/* <input type="text" id="First Name" name="First" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight" required/> */}
				<select name="First" className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight" required>
					{data
						.filter(row => row.Event === event)
						.filter(row => row.House === first)
						.map((row) => {
							return (
								<option
									// value={`${row["Name-1"]} - ${row["Semester-1"]} ${row["Department-1"]} ${row["Division-1"] === "None" ? "" : row["Division-1"]}`}
									value={[...Array(eventdata[event].no_of_members)].map((e, i) => {
										return (
											`${row[`Name-${i + 1}`]} - ${row[`Semester-${i + 1}`]} ${row[`Department-${i + 1}`]} ${row[`Division-${i + 1}`] === "None" ? "" : row[`Division-${i + 1}`]}, `
										)
									})}
									id={row["Name-1"]}
								>
									{`${row["Name-1"]}, ${row["Semester-1"]} ${row["Department-1"]}`}
								</option>
							)
						}
						)}
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='First Score' className="block font-medium mb-2">
					First Score
				</label>
				<input type="number" placeholder="example: 5" onWheel={(e) => e.target.blur()} id="First Score" name="FirstScore" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight" required />
			</div>

			<h3 className="text-2xl text-center font-bold border-t pt-8 mt-8 mb-3">Second</h3>

			<div className="mb-4">
				<label htmlFor='SecondHouse' className="block font-medium mb-2">
					Second House
				</label>
				<select name="SecondHouse" value={second} onChange={(e) => setSecond(e.target.value)} className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight">
					<option value="" id="" selected>--select--</option>
					<option value="Aryans" id="Aryans">Aryans</option>
					<option value="Mughals" id="Mughals">Mughals</option>
					<option value="Rajputs" id="Rajputs">Rajputs</option>
					<option value="Spartans" id="Spartans">Spartans</option>
					<option value="Vikings" id="Vikings">Vikings</option>
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='Second Name' className="block font-medium mb-2">
					Second Name
				</label>
				{/* <input type="text" id="Second " name="Second" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight"/> */}
				<select name="Second" className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight">
					{data
						.filter(row => row.Event === event)
						.filter(row => row.House === second)
						.map((row) => {
							return (
								<option
									value={[...Array(eventdata[event].no_of_members)].map((e, i) => {
										return (
											`${row[`Name-${i + 1}`]} - ${row[`Semester-${i + 1}`]} ${row[`Department-${i + 1}`]} ${row[`Division-${i + 1}`] === "None" ? "" : row[`Division-${i + 1}`]}, `
										)
									})}
									id={row["Name-1"]}
								>
									{`${row["Name-1"]}, ${row["Semester-1"]} ${row["Department-1"]}`}
								</option>
							)
						}
						)}
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='Second Score' className="block font-medium mb-2">
					Second Score
				</label>
				<input type="number" placeholder="example: 5" onWheel={(e) => e.target.blur()} id="Second Score" name="SecondScore" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight" />
			</div>

			<h3 className="text-2xl text-center font-bold border-t pt-8 mt-8 mb-3">Third</h3>

			<div className="mb-4">
				<label htmlFor='ThirdHouse' className="block font-medium mb-2">
					Third House
				</label>
				<select name="ThirdHouse" value={third} onChange={(e) => setThird(e.target.value)} className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight">
					<option value="" id="" selected>--select--</option>
					<option value="Aryans" id="Aryans">Aryans</option>
					<option value="Mughals" id="Mughals">Mughals</option>
					<option value="Rajputs" id="Rajputs">Rajputs</option>
					<option value="Spartans" id="Spartans">Spartans</option>
					<option value="Vikings" id="Vikings">Vikings</option>
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='Third' className="block font-medium mb-2">
					Third Name
				</label>
				{/* <input type="text" id="Third" name="Third" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight"/> */}
				<select name="Third" className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow leading-tight">
					{data
						.filter(row => row.Event === event)
						.filter(row => row.House === third)
						.map((row) => {
							return (
								<option
									value={[...Array(eventdata[event].no_of_members)].map((e, i) => {
										return (
											`${row[`Name-${i + 1}`]} - ${row[`Semester-${i + 1}`]} ${row[`Department-${i + 1}`]} ${row[`Division-${i + 1}`] === "None" ? "" : row[`Division-${i + 1}`]}, `
										)
									})}
									id={row["Name-1"]}
								>
									{`${row["Name-1"]}, ${row["Semester-1"]} ${row["Department-1"]}`}
								</option>
							)
						}
						)}
				</select>
			</div>

			<div className="mb-4">
				<label htmlFor='Third Score' className="block font-medium mb-2">
					Third Score
				</label>
				<input type="number" placeholder="example: 5" onWheel={(e) => e.target.blur()} id="Third Score" name="ThirdScore" className="shadow text-black appearance-none border rounded-sm w-full py-2 px-3 leading-tight" />
			</div>

			<div className="mt-8">

				<input type="submit" value={loading ? "Loading..." : "SUBMIT"} className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-sm shadow-sm text-white bg-amber-500 hover:bg-amber-600" />
			</div>
		</form>
	)
}

export default ResultEntry;

